import { render, staticRenderFns } from "./DashboardBannerCard.html?vue&type=template&id=974f38ae&scoped=true&"
import script from "./DashboardBannerCard.js?vue&type=script&lang=js&"
export * from "./DashboardBannerCard.js?vue&type=script&lang=js&"
import style0 from "./DashboardBannerCard.scss?vue&type=style&index=0&id=974f38ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974f38ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VImg,VSkeletonLoader})
